import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQuizById, getQuizIdsByScenario } from "../api/quiz";
import { setQuizCache } from "../redux/actions";
import {
	getNextRoute,
	getScenarioIdForQuizPage,
	getQuizIndexForQuizPage,
} from "../utils/nextRoutePreload";

/**
 * Precarga el quiz de la siguiente pantalla cuando la siguiente es una página de quiz.
 * Así al hacer clic en "Avanzar" los datos ya están en Redux y no hay espera.
 * Para escenarios con varias preguntas (ej. scenario7-2, scenario7-3) se precarga el quiz del índice correspondiente.
 */
export function usePreloadNextQuiz(pathname) {
	const dispatch = useDispatch();
	const gameId = useSelector((state) => state?.group?.game);
	const quizCache = useSelector((state) => state?.quizCache) || {};
	const cacheRef = useRef(quizCache);
	cacheRef.current = quizCache;

	useEffect(() => {
		if (!pathname || !gameId) return;

		const nextRoute = getNextRoute(pathname);
		if (!nextRoute) return;

		const scenarioId = getScenarioIdForQuizPage(nextRoute);
		if (!scenarioId) return;

		const quizIndex = getQuizIndexForQuizPage(nextRoute);
		const cacheKey = quizIndex === 0 ? scenarioId : `${scenarioId}-${quizIndex}`;
		if (cacheRef.current[cacheKey]) return;

		const params = { game: gameId };
		getQuizIdsByScenario(scenarioId, params)
			.then((listRes) => {
				const list = listRes?.data && Array.isArray(listRes.data) ? listRes.data : [];
				const quizId = list[quizIndex]?._id;
				if (!quizId) return Promise.resolve(null);
				return getQuizById(quizId).then((res) => ({ res, quizId }));
			})
			.then((payload) => {
				if (!payload?.res?.data) return;
				dispatch(
					setQuizCache(cacheKey, {
						resolvedQuizId: payload.quizId,
						data: payload.res.data,
					})
				);
			})
			.catch(() => {});
	}, [pathname, gameId, dispatch]);
}
